import { render, staticRenderFns } from "./SwitchPlan.vue?vue&type=template&id=39da711a&scoped=true&"
import script from "./SwitchPlan.vue?vue&type=script&lang=js&"
export * from "./SwitchPlan.vue?vue&type=script&lang=js&"
import style0 from "./SwitchPlan.vue?vue&type=style&index=0&id=39da711a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da711a",
  null
  
)

export default component.exports